import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Identifiable,
  List,
  Project,
  ListsRetrievalError,
  ListsRetrievalFilter,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  lists: Identifiable<List>;
  error: ListsRetrievalError;
  canRetrieveNextLists: boolean;
  callCount: number;
  retrieveLists(request: Boundaries["retrieveLists"]["request"]): void;
}

function useListsRetrieval(
  project: Identifiable<Project>,
  filter: ListsRetrievalFilter,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isListsRetrievalRequestPending(project, filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isListsRetrievalRequestSuccess(project, filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isListsRetrievalRequestFailure(project, filter),
    ),
    lists: useSelector(() => selector.getLists(project, filter)),
    error: useSelector(() => selector.getListsRetrievalError(project, filter)),
    canRetrieveNextLists: useSelector(() =>
      selector.canRetrieveNextLists(project, filter),
    ),
    callCount: useSelector(() => selector.getListsCallCount(project, filter)),
    retrieveLists: core.retrieveLists,
  };
}

export { useListsRetrieval };
